import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidePanelStateService {
  private sidePanelExpandedSubject = new BehaviorSubject<boolean>(false);
  sidePanelExpanded$ = this.sidePanelExpandedSubject.asObservable();

  setSidePanelExpanded(expanded: boolean): void {
    this.sidePanelExpandedSubject.next(expanded);
  }

  getSidePanelState(): boolean {
    return this.sidePanelExpandedSubject.value;
  }
}
